import { useState } from 'react';
import { useHeightTransition } from './useHeightTransition';

export const useCollapse = (
  sectionKey: string,
  defaultCollapsed: boolean = false
) => {
  const [collapsedStates, setCollapsedStates] = useState<
    Record<string, boolean>
  >({});

  const isCollapsed = collapsedStates[sectionKey] ?? defaultCollapsed;

  // Transition state and height management for Bootstrap-like collapse
  const { contentRef, status, isTransitioning } = useHeightTransition({
    isOpen: !isCollapsed,
    duration: 350,
  });

  const onToggleCollapse = () => {
    setCollapsedStates((prev) => ({
      ...prev,
      [sectionKey]: !(prev[sectionKey] ?? defaultCollapsed),
    }));
  };

  return {
    onToggleCollapse,
    isExpanded: !isCollapsed,
    show: status === 'entered',
    isTransitioning,
    contentRef,
  };
};
